import dialogUtil from '../../_helpers/dialogUtil';
import apiStatus from "../../_helpers/apiStatus";
import formValidationUtil from '../../_helpers/formValidationUtil';


class EditProfileController {
  constructor(AuthService, $state, $scope) {
    'ngInject';

    this.name = 'editProfile';
    this.formId = "profile_form"
    //this.clientService = ClientService;
    this.authService = AuthService;
    this.scope = $scope;
    this.state = $state;
    this.userProfile = undefined;
    this.formValidator = undefined;

  }

  $onInit() {
    this.formValidator = formValidationUtil.initValidation(this.formId);
    this.populateUserProfile();

    $("input").attr("autocomplete", "off");   //turn autocomplete off on all input fields

    const parent = this;
    $('#' + this.formId + ' .phone').on('input', function (event) {
      let inputType = event.originalEvent.inputType;

      if(inputType && !inputType.startsWith('insert')) {
        return;
      }

      //only format if not erasing
      parent.formatPhone($(this));

      if(!inputType) {
        parent.formValidator.validate();
      }
    });
  }

  formatPhone(elem) {
    let phoneNumber = elem.val();

    const cleanNum = phoneNumber.toString().replace(/[\-]/g, '');
    const match = cleanNum.match(/^(\d{3,3})(\d{0,3})(\d{0,4})(.*)$/);

    let newPhone = phoneNumber;
    if (match) {
      newPhone = match[1] + '-' + (match[2] ? match[2].length < 3 ? match[2] : match[2] + "-" : "") + match[3] + match[4];
    }

    $(elem).val(newPhone);
  }

  populateUserProfile() {
    this.authService.getUserProfile((result)=>{
      if(result.apiStatus === apiStatus.SUCCESS) {
        this.userProfile = result.data;
        formValidationUtil.setFormDetails(this.formId, this.userProfile);
      } else {
        dialogUtil.showErrorMessage("Error getting user profile: " + result.apiStatus);
      }
  });
  }

  saveProfile() {
    let tmpData = formValidationUtil.validateFormDetails(this.formId);

    if(!tmpData) {
      dialogUtil.showErrorMessage("Please review and fix all fields before resubmitting");
    } else {
      this.authService.updateUserProfile(tmpData, (result)=>{
        if(result.apiStatus === apiStatus.SUCCESS) {
          dialogUtil.showSuccessMessage("Profile updated successfully!");
        } else {
          dialogUtil.showErrorMessage("Error updating user profile: " + result.apiStatus);
        }
      });
    }
  }
}

export default EditProfileController;



// WEBPACK FOOTER //
// ./client/app/components/editProfile/editProfile.controller.js